import { EmptyState } from '../../../components/ui/EmptyState';

export function CommunicationUnavailable() {
  return (
    <div style={{ padding: '2.25rem 2.5rem', maxWidth: 720 }}>
      <EmptyState
        title="Comunicação ainda não disponível"
        copy="Os avisos pelo Zeladoria serão retomados quando o app da casa estiver disponível."
      />
    </div>
  );
}
